import {
  handleCatchErrors,
  responseDataFormat,
} from "../../../middlewares/resolveRequests";
import {
  addActivityProcedureCommentData,
  addCommentData,
  getActivityProcedureCommentsById,
  getCommentsById,
} from "../../../services/comments/comments";

export const addComment = async (procId, data, token) => {
  let response;
  try {
    response = await addCommentData(procId, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getComments = async (procId, token) => {
  let response;
  try {
    response = await getCommentsById(procId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getActivityProcedureComments = async (procId, token) => {
  let response;
  try {
    response = await getActivityProcedureCommentsById(procId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addActivityComment = async (procId, data, token) => {
  let response;
  try {
    response = await addActivityProcedureCommentData(procId, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
